/**
 * Unified date formatting utility
 * Formats dates consistently across the application
 * Format: MM/DD/YYYY HH:MM AM/PM
 */

export const formatDate = (dateString) => {
  if (!dateString) {
    return "غير محدد";
  }

  try {
    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "تاريخ غير صحيح";
    }

    // Format as MM/DD/YYYY HH:MM AM/PM
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    const hoursStr = String(hours).padStart(2, "0");

    return `${month}/${day}/${year} ${hoursStr}:${minutes} ${ampm}`;
  } catch (error) {
    console.error("Error formatting date:", error, "Input:", dateString);
    return "خطأ في تنسيق التاريخ";
  }
};

export default formatDate;
